// Detalhe da origem de cada mudança do "o que mudou" (spec erpAPINode 2026-10-09-fat-origem-mudancas).
// O back já entrega só o que pode ser mostrado ao cliente (primeiro nome, sem outro cliente).

// 'YYYY-MM-DD HH:MM' (Brasília) -> 'DD/MM/YYYY HH:MM'
export const fmtDataOrigem = (s) => {
    if (!s) return '—';
    const [d, h] = String(s).split(' ');
    const [a, m, dia] = d.split('-');
    return `${dia}/${m}/${a}${h ? ` ${h}` : ''}`;
};

export const rotuloMovimento = (m) => {
    const base = m.tipo === 'entrada' ? 'Entrada' : 'Saída';
    return m.observacao ? `${base} (${m.observacao})` : base;
};

export const temDetalhe = (origem) => Boolean(origem && (
    (origem.movimentacoes && origem.movimentacoes.length)
    || (origem.ajustes && origem.ajustes.length)
    || (origem.eventos && origem.eventos.length)));

export const fmtCompCurta = (ymd) => `${String(ymd).slice(5, 7)}/${String(ymd).slice(0, 4)}`;
